// extracted by mini-css-extract-plugin
export default {"search":"Search_search__YAYIU","searchBody":"Search_searchBody__Xn6Dv"};